import BaseModel from "../default/base-model";
import {PartNumber} from "./project";

export class FtBom extends BaseModel {
    id?: number;
    foxconn_part_number: string;
    description_english?: string;
    description_portuguese?: string;

    constructor() {
        super();
        this.id = undefined;
        this.foxconn_part_number = "";
        this.description_english = "";
        this.description_portuguese = "";
    }
}

export class GroupedFtBom extends BaseModel {
  client_id: number;
  client_name: string;
  ft_bom: string;
  total_produced: number;
  total_jiga: number;
  part_numbers: string;
  status_mount: boolean;
  reuse: boolean;
  alert_group: boolean;
  alert_priority: boolean;
  alert_usage: boolean;

  constructor() {
    super();
    this.client_id = 0;
    this.client_name = "";
    this.ft_bom = "";
    this.total_produced = 0;
    this.total_jiga = 0;
    this.part_numbers = "";
    this.reuse = false;
    this.status_mount = false;
    this.alert_group = false;
    this.alert_priority = false;
    this.alert_usage = false;
  }
}

export class SavePartNumber {
    client_id: number;
    project_id: number;
    ft_bom: string;
    part_numbers: PartNumber[];
    jiga: number;
    rma: number;

    constructor() {
        this.client_id = 0;
        this.project_id = 0;
        this.ft_bom = "";
        this.part_numbers = [];
        this.jiga = 0;
        this.rma = 0;
    }
}

export class MountJigaGroup {
	ft_bom: string;
	alternative_group_bom: string;
	usage: number;
	total: number;
	has_reused: boolean;
	selected: boolean;
	can_reuse_material: boolean;

	constructor() {
		this.ft_bom = "";
		this.alternative_group_bom = "";
		this.usage = 0;
		this.total = 0;
		this.has_reused = false;
		this.selected = false;
		this.can_reuse_material = false;
	}

}

export class MountJiga {
    id: number;
    ft_bom: string;
    alternative_group_bom: string;
    foxconn_part_number: string;
    description_english: string;
    description_portuguese: string;
    usage: number;
    group: string | null;
    used_in_jiga: boolean;
    quantity_jiga: number;
    total_jiga: number;
    origin: number;
    can_reuse_material: boolean;
    has_reused: boolean;
    active: boolean;
    qty_reused?: number;
	quantity_origin_jiga: number | undefined = 0;

    constructor() {
        this.id = 0;
        this.ft_bom = "";
        this.alternative_group_bom = "";
        this.foxconn_part_number = "";
        this.description_english = "";
        this.description_portuguese = "";
        this.usage = 0;
        this.group = null;
        this.used_in_jiga = false;
        this.quantity_jiga = 0;
        this.total_jiga = 0;
        this.origin = 0;
        this.can_reuse_material = false;
        this.has_reused = false;
        this.active = true;
    }

}

export class MountRma extends MountJiga {
    total_rma: number = 0;
    quantity_rma: number = 0;
    quantity_sent_rma: number | undefined = 0;
    used_in_rma = false;

    constructor() {
        super();
    }
}

export const originOptions = [
    { id: 1, label: "Estoque", color: "success" },
    { id: 2, label: "Reutilizado", color: "warning" },
    { id: 3, label: "Misto", color: "secondary" },
]

export class ReuseFtbMaterial {
    id: number;
    ft_bom: string;
    total_available: number;
    total_reuse?: number;
    origin?: number;
    total_used?: number;
    total_material: number;

    constructor() {
        this.id = 0;
        this.ft_bom = "";
        this.total_available = 0;
        this.origin = 0; // Default to "Estoque"
        this.total_reuse = 0;
        this.total_used = 0;
        this.total_material = 0;
    }
}

export enum ReuseFtbMaterialOrigin {
    ESTOQUE = 1,
    REUTILIZADO = 2,
    MISTO = 3
}

